import { PageHeader } from '@hemmafixa/ui';
import { Navigate } from 'react-router';
import { useI18n } from '@/i18n/context';
import { BackLink } from '../shared/back-link';
import { PublicProviderProfileView } from '../shared/public-provider-profile';
import { QueryView } from '../shared/query-view';
import { useProviderProfile, usePublicProvider } from './api';

/** The provider's own public profile, exactly as clients see it (P2-11). Only verified profiles have one. */
export function PublicProfilePage() {
  const { t } = useI18n();
  const own = useProviderProfile();
  const verifiedId = own.data?.status === 'verified' ? own.data.id : undefined;
  const query = usePublicProvider(verifiedId);

  if (own.isSuccess && !verifiedId) return <Navigate to="/provider/onboarding" replace />;

  return (
    <div className="mx-auto grid w-full max-w-3xl gap-4">
      <BackLink to="/provider/onboarding" label={t.nav.companyProfile} />
      <PageHeader title={t.publicProfile.title} description={t.publicProfile.preview} />
      {verifiedId ? (
        <QueryView query={query} loading="detail">
          {(profile) => profile && <PublicProviderProfileView profile={profile} />}
        </QueryView>
      ) : (
        // Waiting for (or failed to load) the provider's own profile; QueryView shows the error with Try again
        <QueryView query={own} loading="detail">
          {() => null}
        </QueryView>
      )}
    </div>
  );
}
